import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Info, AlertTriangle, AlertOctagon, X, PauseCircle } from "lucide-react";
import { api } from "../lib/api";

const LEVELS = {
  info: { cls: "bg-blue-50 border-blue-200 text-blue-900", icon: Info },
  warning: { cls: "bg-amber-50 border-amber-300 text-amber-900", icon: AlertTriangle },
  urgent: { cls: "bg-red-50 border-red-300 text-red-900", icon: AlertOctagon },
};
const DISMISS_KEY = "qf_notice_dismissed";

export default function GlobalNotice() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [notice, setNotice] = useState(null);
  const [suspended, setSuspended] = useState(false);
  const [dismissed, setDismissed] = useState(localStorage.getItem(DISMISS_KEY) || "");

  useEffect(() => {
    api.get("/billing/config").then((r) => setNotice(r.data.global_notice)).catch(() => {});
    api.get("/billing/status").then((r) => setSuspended(r.data.subscription_status === "suspended")).catch(() => {});
  }, [pathname]);

  const showNotice = notice?.enabled && notice.text && dismissed !== notice.version;
  const lv = LEVELS[notice?.level] || LEVELS.info;
  const Icon = lv.icon;

  return (
    <>
      {showNotice && (
        <div data-testid="global-notice" data-level={notice.level} className={`mb-5 rounded-xl border px-4 py-3 flex items-start gap-3 ${lv.cls}`}>
          <Icon style={{ width: 18, height: 18 }} className="shrink-0 mt-0.5" />
          <p className="text-sm font-medium flex-1" data-testid="global-notice-text">{notice.text}</p>
          <button data-testid="global-notice-close" title="Chiudi" onClick={() => { localStorage.setItem(DISMISS_KEY, notice.version); setDismissed(notice.version); }} className="opacity-60 hover:opacity-100">
            <X style={{ width: 16, height: 16 }} />
          </button>
        </div>
      )}
      {suspended && (
        <div data-testid="suspended-banner" className="mb-5 rounded-xl border border-amber-300 bg-amber-100/70 px-4 py-3 flex items-center gap-3 flex-wrap">
          <PauseCircle style={{ width: 18, height: 18 }} className="text-amber-700 shrink-0" />
          <p className="text-sm font-semibold text-amber-900 flex-1">Il tuo abbonamento è in pausa. Riattivalo per creare nuovi preventivi.</p>
          {pathname !== "/billing" && (
            <button data-testid="suspended-banner-cta" onClick={() => navigate("/billing")} className="text-sm font-semibold text-white bg-amber-600 hover:bg-amber-700 rounded-lg px-3 py-1.5">Gestisci abbonamento</button>
          )}
        </div>
      )}
    </>
  );
}
